import script from "./RecentDiscountTransactionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentDiscountTransactionItem.vue?vue&type=script&setup=true&lang=ts"

import "./RecentDiscountTransactionItem.vue?vue&type=style&index=0&id=9494ed9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9494ed9c"]])

export default __exports__